import React from "react"

import {H2, H3, Body} from "@irati/ui/src/Typography"
import FormattedMessage, {FormattedNumber, injectIntl, InjectIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import GenericModal from "@irati/ui/src/GenericModal"
import Markdown from "@irati/ui/src/Markdown"
import authentication from "@irati/auth"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {DistributeRewardImportType, DistributeRewardRecipient} from "../../../enums/DistributeRewardTypes"
import {useRewardsDistribution} from "../../../stores/DistributeReward/hooks"

interface Props extends InjectIntl {
  onClose: () => void
}

const DistributeRewardSuccessModal: React.FC<Props> = ({formatMessage, onClose}) => {
  const {
    userEmails,
    destinationUsers,
    modalConfirmIsShown,
    bulkBudgetAssignmentState,
    rewardImportType,
    pointsPerUser,
    schedule,
    recipientType
  } = useRewardsDistribution()
  const senderEmail = authentication.user().email
  const isScheduled = schedule?.isScheduled

  const totUsers = rewardImportType === DistributeRewardImportType.IMPORT_CSV ? userEmails.length : destinationUsers.length
  const totalToPay =
    rewardImportType === DistributeRewardImportType.IMPORT_CSV && recipientType === DistributeRewardRecipient.MANAGER
      ? bulkBudgetAssignmentState.totalToPay
      : pointsPerUser * totUsers || 0

  return (
    <GenericModal show={modalConfirmIsShown} onHide={onClose} onExited={onClose} hideActions>
      <H2 textAlign="center" marginBottom={2}>
        {isScheduled ? (
          <FormattedMessage id="wallet.reward.csv.modal.title.scheduled" />
        ) : (
          <FormattedMessage id="wallet.reward.csv.modal.title.rewardOnGoing" />
        )}
      </H2>
      <H3>
        <Flex alignItems="center" gap=".5rem" justifyContent="center" marginTop={2} marginBottom={2}>
          <Icon icon={IconTypes.rewardPoints} size={32} />
          <FormattedNumber value={totalToPay} />
          <FormattedMessage id="wallet.reward.admin.confirmationModal.points" />
        </Flex>
      </H3>
      <Body marginBottom={4}>
        <Markdown
          source={formatMessage(
            {id: isScheduled ? "wallet.reward.csv.modal.bodyScheduled" : "wallet.reward.csv.modal.body"},
            {senderEmail}
          )}
        />
      </Body>
      <Button large full primary onClick={onClose}>
        <FormattedMessage id="platform.ui.banner.cta.gotIt" />
      </Button>
    </GenericModal>
  )
}

export default injectIntl(DistributeRewardSuccessModal)
